<div class="like" (click)="getLike()">
  <fa-icon [icon]="isLike? faThumbsUp : faThumbsUpFull"></fa-icon>
</div>
